/**!
 * Created by Leonardo Cheslacki on 31/03/2025.
 *
 * MIT License
 *
 * Copyright (c) 2025 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import config from '../../../../config';

const {default: {domain, routes: {web}, gallery}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class StageGallery extends StageController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: [] || {}
        };

        this.$window = null;

        this.$document = null;

        this.$galleryClass = null;

        this.$gallery_list = null;

        this.$gallery_arrow_left = null;

        this.$gallery_arrow_right = null;

        _this = this;
    };

    $styles = {
        zoomFullscreen: {
            zoomBackground: {
                backgroundColor: '#394539',
                maxWidth: '100vw',
                maxHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0 auto',
                position: 'absolute',
                left: '0',
                right: '0',
                top: '0',
                bottom: '0',
                zIndex: '1000'
            },
            zoomImg: {
                maxWidth: '100vw',
                maxHeight: '100vh'
            }
        },
        zoomButton: {
            zoomIcon: {
                width: '30px',
                height: '30px'
            },
            zoomButton: {
                cursor: 'pointer',
                position: 'absolute',
                bottom: '-45px',
                right: '-45px',
                padding: '10px'
            }
        }
    };

    $functions = {
        handlePrev: function () {
            _this.$galleryClass.go('-1');
        },

        handleNext: function () {
            _this.$galleryClass.go('+1');
        },

        /**
         *
         * @param event
         * @param src
         */
        handleZoom: function (event, {src}) {
            const supportStyle = _this.main.$supportStyle();

            supportStyle.setStyle(_this.$styles.zoomFullscreen);

            supportStyle.create('zoom-full-screen');

            const app = document.getElementById('app');

            let
                zoom_background = document.createElement('DIV'),
                zoom_img = document.createElement('IMG'),
                zoom_close = document.createElement('IMG');

            const close = () => {
                _this.setAttributes(zoom_background, {class: 'zoom-background animate__animated animate__fadeOut'});
            };

            const animateEnd = ({animationName}) => {
                if (animationName === 'fadeOut') {
                    _this.removeListener('animationend', 'animationend-zoom', () => {
                        zoom_background.remove();
                    });
                    _this.removeListener('click', 'click-close-overlay-container', () => {
                        zoom_close.remove();
                    });

                    supportStyle.remove('zoom-full-screen');
                }
            };

            _this.setAttributes(zoom_background, {
                class: 'zoom-background animate__animated animate__fadeIn'
            });

            _this.setAttributes(zoom_img, {
                class: 'zoom-img',
                src: _this.getUriImage(src),
                alt: 'zoom-img'
            });

            _this.setAttributes(zoom_close, {
                id: 'close_overlay_container',
                alt: 'close',
                src: _this.getUriImage('close.png')
            });

            _this.removeListener('animationend', 'animationend-zoom', () => {
                _this.addListener(zoom_background, 'animationend', 'animationend-zoom', animateEnd);
            });

            _this.removeListener('click', 'click-close-overlay-container', () => {
                _this.addListener(zoom_close, 'click', 'click-close-overlay-container', close);
            });

            zoom_background.appendChild(zoom_img);

            zoom_background.appendChild(zoom_close);

            app.appendChild(zoom_background);
        }
    };

    /**
     *
     * @param property
     * @returns {*}
     */
    createElement = (property) => {
        let
            _id = this.verifyField(property, 'attributes.id').value,
            value_src = this.verifyField(property, 'product.src.value'),
            value_text = this.verifyField(property, 'product.text.value'),
            value_warn = this.verifyField(property, 'product.warn.value'),
            value_description = this.verifyField(property, 'product.description.value'),
            attribute_allow = this.getNodeAttribute(property, 'allow');

        if (this.hasString(attribute_allow, 'gallery') && value_src) {
            const createLi = () => {
                let li = this.$document.createElement('LI');

                li.setAttribute('class', 'splide__slide');

                return li;
            };

            const createFigure = () => {
                let figure = this.$document.createElement('FIGURE');

                figure.setAttribute('class', 'splide__slide__container');

                return figure;
            };

            const createImg = () => {
                let img = this.$document.createElement('IMG');

                img.setAttribute('src', this.getUriImage(value_src));

                img.setAttribute('alt', value_text ? this.toSlug(value_text.toLowerCase()) : 'image');

                return img;
            };

            const createFigcaption = () => {
                let figcaption = this.$document.createElement('FIGCAPTION');

                figcaption.setAttribute('class', 'legend');

                return figcaption;
            };

            const createPLeft = () => {
                let p = this.$document.createElement('P');

                p.setAttribute('class', 'legend-p legend-p-left');

                return p;
            };

            const createPRight = () => {
                let p = this.$document.createElement('P');

                p.setAttribute('class', 'legend-p legend-p-right');

                return p;
            };

            const createTextNode = () => {
                return this.$document.createTextNode(this.toCapitalize(value_text));
            };

            const createButtonZoom = () => {
                const supportStyle = this.main.$supportStyle();

                supportStyle.setStyle(this.$styles.zoomButton);

                supportStyle.create('zoom-button', this.$document);

                let
                    div = this.$document.createElement('DIV'),
                    img = this.$document.createElement('IMG');

                this.setAttributes(img, {
                    class: 'zoom-icon',
                    alt: 'zoom-icon',
                    src: this.getUriImage('zoom.png'),
                    width: this.calcSize(1, stage.scaleX, 30, false, 'int'),
                    height: this.calcSize(1, stage.scaleY, 30, false, 'int')
                });

                this.setAttributes(div, {class: 'zoom-button'});

                div.appendChild(img);

                this.removeListener('click', `click-zoom-${_id}`, () => {
                    this.addListener(div, 'click', `click-zoom-${_id}`, this.$functions.handleZoom, false, {
                        src: value_src
                    });
                });

                return div;
            };

            const createWarnNode = () => {
                value_warn = this.toCapitalize(value_warn);
                //value_warn = `${value_warn.charAt(0).toUpperCase()}${value_warn.slice(1).toLowerCase()}`;
                return this.$document.createTextNode(value_warn);
            };

            const createDescriptionNode = () => {
                value_description = this.toCapitalize(value_description);
                //value_description = `${value_description.charAt(0).toUpperCase()}${value_description.slice(1).toLowerCase()}`;
                return this.$document.createTextNode(value_description);
            };

            let
                li = createLi(),
                figure = createFigure(),
                img = createImg(),
                zoom = createButtonZoom();

            figure.appendChild(img);

            figure.appendChild(zoom);

            if (value_text) {
                let
                    figcaption = createFigcaption(),
                    text = createTextNode();

                figcaption.appendChild(text);
                figure.appendChild(figcaption);
            }

            if (value_warn) {
                let
                    p = createPLeft(),
                    text = createWarnNode();

                p.appendChild(text);
                figure.appendChild(p);
            }

            if (value_description) {
                let
                    p = createPRight(),
                    text = createDescriptionNode();

                p.appendChild(text);
                figure.appendChild(p);
            }

            li.appendChild(figure);

            return li;
        }
    };

    startGallery = () => {
        const {data} = this.state;

        for (let property of data) {
            let element = this.createElement(property);
            element && this.$gallery_list.appendChild(element);
        }
    };

    /**
     *
     * @returns {*}
     */
    createOverlayContainer = () => {
        /**
         *
         * @param _id
         * @param className
         * @returns {*}
         */
        const createDiv = (_id = null, className = null) => {
            let div = this.$document.createElement('DIV');

            !this.isEmpty(_id) && div.setAttribute('id', _id);

            !this.isEmpty(className) && div.setAttribute('class', className);

            return div;
        };

        /**
         *
         * @param _id
         * @param className
         * @returns {*}
         */
        const createUl = (_id = null, className = null) => {
            let ul = this.$document.createElement('UL');

            !this.isEmpty(_id) && ul.setAttribute('id', _id);

            !this.isEmpty(className) && ul.setAttribute('class', className);

            return ul;
        };

        /**
         *
         * @param _id
         * @param className
         * @param viewBox
         * @returns {*}
         */
        const createSvg = (_id = null, className = null, viewBox = null) => {
            let svg = this.$document.createElementNS('http://www.w3.org/2000/svg', 'svg');

            !this.isEmpty(_id) && svg.setAttribute('id', _id);

            !this.isEmpty(className) && svg.setAttribute('class', className);

            !this.isEmpty(viewBox) && svg.setAttribute('viewBox', viewBox);

            return svg;
        };

        /**
         *
         * @param _id
         * @param className
         * @param points
         * @returns {*}
         */
        const createPolyline = (_id = null, className = null, points = null) => {
            let polyline = this.$document.createElementNS('http://www.w3.org/2000/svg', 'polyline');

            !this.isEmpty(_id) && polyline.setAttribute('id', _id);

            !this.isEmpty(className) && polyline.setAttribute('class', className);

            !this.isEmpty(points) && polyline.setAttribute('points', points);

            return polyline;
        };

        let
            divContainer = createDiv('gallery_overlay_container', 'splide'),
            divTrack = createDiv('track', 'splide__track'),
            svgLeft = createSvg(null, 'gallery-arrow-icon', '0 0 16000 16000'),
            polylineLeft = createPolyline(null, 'a', '11040, 1920 4960, 8000 11040, 14080'),
            svgRight = createSvg(null, 'gallery-arrow-icon', '0 0 16000 16000'),
            polylineRight = createPolyline(null, 'a', '4960, 1920 11040, 8000 4960, 14080');

        this.$gallery_list = createUl('gallery_list', 'splide__list');
        this.$gallery_arrow_left = createDiv('gallery_arrow_left');
        this.$gallery_arrow_right = createDiv('gallery_arrow_right');

        divTrack.appendChild(this.$gallery_list);
        divContainer.appendChild(divTrack);

        svgLeft.appendChild(polylineLeft);
        this.$gallery_arrow_left.appendChild(svgLeft);
        divContainer.appendChild(this.$gallery_arrow_left);

        svgRight.appendChild(polylineRight);
        this.$gallery_arrow_right.appendChild(svgRight);
        divContainer.appendChild(this.$gallery_arrow_right);

        return divContainer;
    };

    mainGallery = () => {
        const
            {xml} = this.props,
            {stage: {canvas}} = this.get();

        this.$window = canvas.ownerDocument.defaultView;

        this.$document = canvas.ownerDocument;

        let element = this.createOverlayContainer();

        this.$document.getElementById('animation_container').appendChild(element);

        this.main.on('animate_gallery_complete', () => {
            this.$galleryClass = (new this.$window.Splide(element, gallery.options));

            this.$galleryClass.mount();
        });

        this.main.on('animate_gallery_end', () => {
            this.$galleryClass.destroy();

            this.$galleryClass = null;
        });

        this.getForm(`${this.$base_uri || domain}/${web.uri_xml}/${xml}`, {}, {
            done: (response) => {
                let
                    object = this.firstArray(this.xmlToJson(response)),
                    products = this.getObject(object, 'products');

                this.setState({...this.state, data: products}, this.startGallery);
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.removeListener('click', 'click-prev-gallery', () => {
                    this.addListener(this.$gallery_arrow_left, 'click', 'click-prev-gallery', this.$functions.handlePrev);
                });

                this.removeListener('click', 'click-next-gallery', () => {
                    this.addListener(this.$gallery_arrow_right, 'click', 'click-next-gallery', this.$functions.handleNext);
                });
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
StageGallery.propTypes = {
    current_name: PropTypes.string,
    xml: PropTypes.string,
};

/**
 *
 * @type {{}}
 */
StageGallery.defaultProps = {
    current_name: null,
    xml: 'galley.xml'
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StageGallery, {className: 'StageGallery'});
